import { useEffect, useState } from "react";
// Components
import DirectoryBreadCrumb from "view/components/Breadcrumbs/DirectoryBreadCrumb";
import { Toasts } from "view/components/Toasts";
import { PageHeading } from "./components";

// APIs Services
import apiLibrary from "services/api";
// Store Utils
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { RootState } from "store";
import {
  observationsCommunityAction,
  observationsProgramsAction,
} from "store/filters/reducer.actions";
import { sentenceCase } from "change-case";
import { filtersInitialState } from "store/filters/initialState";
import { updateColumnsVisibilityOfObservationsByStatus } from "store/directoriesOrders/reducer.actions";

const generateDynamicObservationsLinks = (
  communityId: any,
  programId: any,
  name: any,
  label: any
) => {
  switch (true) {
    case Boolean(communityId):
      return [
        { path: `/community/list`, label: `Communities` },
        {
          path: `/community/${communityId}/profile`,
          label: name,
        },
        {
          path: `/community/${communityId}/observations`,
          label: `Observations`,
        },
      ];
    case Boolean(programId):
      return [
        {
          path: `/programs/list`,
          label: `Programs`,
        },
        {
          path: `/programs/${programId}/profile`,
          label: name,
        },
        {
          path: `/programs/${programId}/observations`,
          label: `Observations`,
        },
      ];
    default:
      return [{ path: `/observations/list`, label: `Observations` }];
  }
};

export const Header = () => {
  const [BreadcrumbData, setBreadcrumbData] = useState({
    name: "",
    id: "",
  });
  const { observationsFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const { programId, communityId } = useParams<{
    programId: string;
    communityId: string;
  }>();

  const dynamicObservationsLinks = generateDynamicObservationsLinks(
    communityId ?? "",
    programId ?? "",
    BreadcrumbData?.name ?? "",
    observationsFilter.status
  );

  const navigate = useNavigate();
  useEffect(() => {
    if (programId) {
      getProgramDetails(programId)
        .then((data) => {
          // fetching programs according to specific filteration
          // dispatch(
          //   observationsProgramsAction({
          //     name: data.name,
          //     id: programId,
          //   })
          // );
          dispatch(updateColumnsVisibilityOfObservationsByStatus("program"));
          setBreadcrumbData(data);
        })
        .catch((error) => {
          const errMsg = error?.response?.data?.message ?? error.message;
          Toasts.error(errMsg);
          navigate("/programs/list");
        });
    } else if (communityId) {
      getCommunityDetails(communityId)
        .then((data) => {
          // fetching communities according to specific filteration
          // dispatch(
          //   observationsCommunityAction({
          //     name: data.name,
          //     id: communityId,
          //   })
          // );
          dispatch(updateColumnsVisibilityOfObservationsByStatus("community"));
          setBreadcrumbData(data);
        })
        .catch((error) => {
          const errMsg = error?.response?.data?.message ?? error.message;
          Toasts.error(errMsg);
          navigate("/community/list");
        });
    }
  }, [programId, communityId]);

  return (
    <div className="flex items-start self-stretch justify-start flex-grow-0 flex-shrink-0">
      <div className="flex items-start self-stretch justify-start flex-grow">
        <div className="flex flex-col items-start justify-start flex-grow gap-2">
          <DirectoryBreadCrumb links={dynamicObservationsLinks} />
          <div className="flex items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-2">
            <PageHeading
              id={programId ? programId : communityId ? communityId : ""}
              name={BreadcrumbData?.name}
              parentName={
                programId ? "Programs" : communityId ? "Communities" : ""
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// controllers
async function getProgramDetails(programId: string) {
  try {
    const { data } = await apiLibrary.Programs.getProgramProfile(
      programId ? programId : ""
    );
    return data;
  } catch (error: any) {
    throw error;
  }
}

async function getCommunityDetails(communityId: string) {
  try {
    const { data } = await apiLibrary.Communities.getCommunityProfile(
      communityId ? communityId : ""
    );
    return data;
  } catch (error: any) {
    throw error;
  }
}
